/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
==========================================================================================*/

import { ACCESS_META_BY_ROUTE_NAME } from '@/constants/accessTargets'

const withAccessMeta = item => {
  if (!item || !item.slug) return item
  const accessMeta = ACCESS_META_BY_ROUTE_NAME[item.slug]
  if (!accessMeta) return item

  return {
    ...item,
    ...accessMeta,
  }
}

const applyNavAccessRules = items =>
  items.map(item => {
    if (item.header && Array.isArray(item.items)) {
      return {
        ...item,
        items: applyNavAccessRules(item.items),
      }
    }

    if (Array.isArray(item.submenu)) {
      return {
        ...withAccessMeta(item),
        submenu: applyNavAccessRules(item.submenu),
      }
    }

    return withAccessMeta(item)
  })

export default applyNavAccessRules([
  {
    url: "/",
    name: "Home",
    slug: "home",
    icon: "HomeIcon",
  },
  {
    url: "/content",
    name: "Content",
    slug: "content",
    icon: "ListIcon",
  },
  {
    url: null,
    header: "Create content",
    icon: "Edit2Icon",
    items: [
      {
        url: "/create/course",
        name: "Course",
        slug: "create-course",
        icon: "BookIcon",
      },
      {
        url: "/create/video",
        name: "Video",
        slug: "create-video",
        icon: "VideoIcon",
      },
      {
        name: "Quiz",
        icon: "CheckSquareIcon",
        submenu: [
          {
            url: "/bulk/quiz-upload",
            name: "Bulk Quiz Upload",
            slug: "bulk-quiz-upload"
          },
          {
            name: "Create a Quiz",
            url: "/create/quiz",
            slug: "create-quiz",
            icon: "CheckSquareIcon",
          },
        ]
      },
      {
        url: "/create/learning-path",
        name: "Learning Path",
        slug: "create-lp",
        icon: "GitCommitIcon",
      },
      {
        url: "/create/lab",
        name: "Lab",
        slug: "create-lab",
        icon: "GithubIcon",
      },
      {
        url: "/create/exercise",
        name: "Exercise",
        slug: "create-exercise",
        icon: "TerminalIcon",
      },
      {
        url: "/create/iframe",
        name: "iFrame",
        slug: "create-iframe",
        icon: "ExternalLinkIcon",
      },
      {
        name: "Collection",
        icon: "ShoppingBagIcon",
        submenu: [
          {
            url: "/create/collection",
            slug: "create-collection",
            name: "Create a Collection",
          },
          {
            url: "/bulk/collection-upload",
            name: "Bulk Collection Upload",
            slug: "bulk-collection-upload"
          },
        ]
      },
      {
        url: "/create/sonar",
        name: "Skill Sonar",
        slug: "create-sonar",
        icon: "RadioIcon",
      },
      {
        url: "/certifications",
        name: "Certifications",
        slug: "certifications",
        icon: "AwardIcon",
      },
    ]
  },
  {
    url: null,
    header: "Stats",
    icon: "Edit2Icon",
    items: [
      {
        url: "/reports",
        name: "Reports",
        slug: "reports",
        icon: "DownloadCloudIcon",
      },
      {
        url: "/reviews",
        name: "Reviews",
        slug: "reviews",
        icon: "StarIcon",
      },
      {
        url: "/charts",
        name: "Charts",
        slug: "charts",
        icon: "PieChartIcon",
      },
    ]
  }
])
